import auth from './auth'
import transactionFilters from './transactionFilters'

const rootReducer = { auth, transactionFilters }

export default rootReducer
